<template>
  <div class="card-header dash-card-header row flex-shrink-0">
    <div class="row-txt-l width-20">
        <div class="row-txt-header">{{ getKpiName('01. Quality of Pre-Owned Locator Occurrence') }}</div>
        <performanceitem :overallByWave="getOverallByWave"
                         :kpi="getKpiByString('01. Quality of Pre-Owned Locator Occurrence')" />
    </div>

    <div class="row-txt-m width-20">
        <div class="row-txt-header">{{ getKpiName('02. Personal Contact') }}</div>
        <performanceitem :overallByWave="getOverallByWave"
                         :kpi="getKpiByString('02. Personal Contact')" />
    </div>

    <div class="row-txt-m width-20">
        <div class="row-txt-header">{{ getKpiName('03. Quality of Personal Contact') }}</div>
        <performanceitem :overallByWave="getOverallByWave"
                         :kpi="getKpiByString('03. Quality of Personal Contact')" />
    </div>

    <div class="row-txt-m width-20">
        <div class="row-txt-header">{{ getKpiName('04. Appointment Making') }}</div>
        <performanceitem :overallByWave="getOverallByWave"
                         :kpi="getKpiByString('04. Appointment Making')" />
    </div>

    <div class="row-txt-r width-20">
        <div class="row-txt-header">{{ getKpiName('05. Quality of Offer') }}</div>
        <performanceitem :overallByWave="getOverallByWave"
                         :kpi="getKpiByString('05. Quality of Offer')" />
    </div>
  </div>
</template>

<script>
  import performanceitem from './PerformanceItem'
  import KpiMixin from '@/mixins/lambo/KpiMixin';

  export default {
    mixins: [ KpiMixin ],

    components: {
      performanceitem
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/../scss/lambo/variables.scss";

  .dash-card-header {
    height: 90px !important;
  }

  .row-txt-l {
    height: 100%;
    background-color: $lambo-header-color-alt;
    border-right:solid 1px $lambo-header-border;
  }
  .row-txt-m {
    height: 100%;
    background-color: $lambo-header-color-alt;
    border-left:solid 1px $lambo-header-border;
    border-right:solid 1px $lambo-header-border;
  }
  .row-txt-r {
    height: 100%;
    background-color: $lambo-header-color-alt;
    border-left:solid 1px $lambo-header-border;
  }

  .row-txt-header {
    text-align: center;
    font-weight: bold;
    height: 48px;
  }
</style>
